import { Loader2, Mic } from "lucide-react"
import { Button } from "@/components/ui/primitives"
import { ShotTranscriptionView } from "@/components/shot-panel/shot-transcription-view"
import { useTranslation } from "@/hooks/use-translation"

export function ShotAnimaticTranscriptionExtras({
  projectId,
  shotId,
  hasSegment,
  transcribing,
  transcriptionError,
  transcriptionRefreshKey,
  onTranscribe,
  onDataChanged,
}: {
  projectId: number
  shotId: number
  hasSegment: boolean
  transcribing: boolean
  transcriptionError: string | null
  transcriptionRefreshKey: number
  onTranscribe: () => void
  onDataChanged: () => void
}) {
  const { t } = useTranslation(["shot", "common"])

  if (!hasSegment) {
    return (
      <p className="rounded-lg border border-dashed border-ui-border-strong bg-ui-surface-sunken px-3 py-6 text-center text-xs text-ui-text-muted">
        {t("common.noAnimaticSegmentLink")}
      </p>
    )
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-2">
        <p className="text-[11px] leading-snug text-ui-text-muted">{t("common.transcriptionSegmentHint")}</p>
        <Button
          type="button"
          variant="secondary"
          size="sm"
          className="h-7 shrink-0 gap-1.5 px-2 text-[11px]"
          disabled={transcribing}
          onClick={onTranscribe}
        >
          {transcribing ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Mic className="h-3.5 w-3.5" />}
          {t("common.transcribe")}
        </Button>
      </div>
      {transcriptionError ? (
        <p className="text-xs text-ui-status-failed" role="alert">
          {transcriptionError}
        </p>
      ) : null}
      <ShotTranscriptionView
        key={transcriptionRefreshKey}
        projectId={projectId}
        shotId={shotId}
        onDataChanged={onDataChanged}
      />
    </div>
  )
}
